import { render, staticRenderFns } from "./paginationVue.vue?vue&type=template&id=36f0e58a&scoped=true&"
import script from "./paginationVue.vue?vue&type=script&lang=js&"
export * from "./paginationVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f0e58a",
  null
  
)

export default component.exports